import React, {memo, useEffect} from 'react'
import {Button, Dropdown, Message, Radio, Table} from 'semantic-ui-react'
import VersionDocsPreview from './version-docs-preview'
import {withErrorHandling, withHelmet, withPropsPresent, withMeData, withServiceData, withVersionData} from '../../../../hoc'
import {useSafeState} from '../../../../hook'
import {userAccount} from '../../../../util'
import {getContract, upsertEnvironment} from '../../../../backend'


const withContract = (environment, contract) => {
  return {...environment, contract}
}
const _VersionDocs = (
  {
    me,
    service,
    version,
    mutateVersion,
    upsertEnvironment,
    getContract
  }
) => {
  const [state, setState] = useSafeState({
    environments: [],
    updatingDocsPublished: '',
    preview: null,
    updatingDocsAugmented: ''
  })

  useEffect(() => {
    setState({...state, environments: version.environments})
  }, [version])

  const onUpdateDocsPublished = async (e, environment, published) => {
    e.preventDefault()
    setState({...state, updatingDocsPublished: environment.id})
    environment.docs.published = published
    await upsertEnvironment(environment)
    setState({
      ...state,
      environments: version.environments.map(env => {
        if (env.id === environment) {
          return environment
        }
        return env
      })
    })
    mutateVersion()
  }

  const onUpdateDocsAugmented = async (e, environment) => {
    e.preventDefault()
    setState({...state, updatingDocsAugmented: environment.id})
    environment.docs.augment = !environment.docs.augment
    const augmentationParams = {augmentEnvironmentId: environment.docs.augment ? environment.id : ''}
    const contract = await getContract(version.contract, augmentationParams)
    await upsertEnvironment(environment)
    setState({
      ...state,
      environments: version.environments.map(env => {
        if (env.id === environment.id) {
          return withContract(environment, contract)
        }
        return env
      }),
      updatingDocsAugmented: ''
    })
    mutateVersion()
  }

  const onShowPreview = async (e, environment) => {
    e.preventDefault()
    const augmentationParams = {augmentEnvironmentId: environment.docs.augment ? environment.id : ''}
    const contract = await getContract(version.contract, augmentationParams)
    setState({...state, preview: withContract(environment, contract)})
  }

  const onHidePreview = () => {
    setState({...state, preview: null})
  }

  const onView = (e, environment) => {
    e.preventDefault()
    const account = userAccount(me)
    const port = ['', '80'].includes(window.location.port.toString())  ? '' : `:${window.location.port}`
    const href = `${window.location.protocol}//${window.location.hostname}${port}/d/${account.name}/${service.name}/${version.name}/${environment.name}`
    window.open(href, '_blank')
  }

  return (
    <div>
      <Message data-testid='version-docs-message'>The settings below will control what version/environment combo's expose links for public access</Message>
      <Table celled data-testid='version-docs'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Version</Table.HeaderCell>
            <Table.HeaderCell>Environment</Table.HeaderCell>
            <Table.HeaderCell>Published</Table.HeaderCell>
            <Table.HeaderCell>Ref. Mock</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            version.environments.map((environment) => (
              <Table.Row key={environment.id} data-test='version-docs-row'>
                <Table.Cell verticalAlign='top' data-test='version-docs-version-name'>{version.name}</Table.Cell>
                <Table.Cell verticalAlign='top' data-test='version-docs-environment-name'>{environment.name}</Table.Cell>
                <Table.Cell verticalAlign='top'>
                  <Dropdown selection loading={state.updatingDocsPublished === environment.id}
                            options={[{
                              key: 'no',
                              text: 'no',
                              value: 'no'
                            }, {
                              key: 'swagger-docs',
                              text: 'as swagger docs',
                              value: 'swagger-docs'
                            }, {
                              key: 'api-docs',
                              text: 'as api docs',
                              value: 'api-docs'
                            }]}
                            data-test='version-docs-publish-as-dropdown'
                            value={environment.docs.published}
                            onChange={(e, d) => onUpdateDocsPublished(e, environment, d.value)}/>
                </Table.Cell>
                <Table.Cell>
                  {
                    state.updatingDocsAugmented === environment.id && (
                      <Button size='mini' loading={true}/>
                    )
                  }
                  {
                    state.updatingDocsAugmented !== environment.id && (
                      <Radio toggle checked={environment.docs.augment}
                             data-test='version-docs-augmented-radio'
                             onChange={(e) => onUpdateDocsAugmented(e, environment)}/>)
                  }
                </Table.Cell>
                <Table.Cell verticalAlign='top'>
                  {
                    environment.docs.published !== 'no' && (
                      <Button.Group size='tiny'>
                        <Button icon='eye' onClick={(e) => onShowPreview(e, environment)}
                                data-test='version-docs-preview-button'
                                content='preview'/>
                        <Button.Or/>
                        <Button primary icon='linkify' onClick={(e) => onView(e, environment)}
                                data-test='version-docs-view-button'
                                content='view'/>
                      </Button.Group>
                    )
                  }
                  {
                    environment.docs.published === 'no' && (
                      <Button icon='eye' onClick={(e) => onShowPreview(e, environment)}
                              content='preview' data-test='version-docs-preview-button'/>
                    )
                  }
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>
      {
        !!state.preview && (
          <VersionDocsPreview contract={state.preview.contract}
                              display={state.preview.docs.published === 'no' ? 'api-docs' : state.preview.docs.published}
                              onClose={onHidePreview}/>
        )
      }
    </div>
  )
}

let VersionDocs = (props) => {
  const {handleError} = props
  props = {...props, upsertEnvironment: handleError(upsertEnvironment), getContract: handleError(getContract)}
  return (<_VersionDocs {...props}/>)
}

VersionDocs = withPropsPresent(VersionDocs, ['me', 'service', 'version'])
VersionDocs = withHelmet(VersionDocs, 'Docs')
VersionDocs = withMeData(VersionDocs, 'Loading profile...')
VersionDocs = withServiceData(VersionDocs, 'Loading service...')
VersionDocs = withVersionData(VersionDocs, 'Loading version...')
VersionDocs = withErrorHandling(VersionDocs)
VersionDocs = memo(VersionDocs)

export {_VersionDocs, VersionDocs}

export default VersionDocs